import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { Layout, Menu, Breadcrumb, Icon, Card } from 'antd';
import '../../assets/css/App.css';
import routes from '../../model/router';
import Header1 from '../public';
import BicombImg from "../../assets/images/clarityICI.jpg";
import DemoVideo from "../../assets/videos/clarity_ici_demo.mp4";


// ===============================
// 2) Color scale helper (blue -> white -> green)
// ===============================
const lerp = (a, b, t) => a + (b - a) * t;

function hexToRgb(hex) {
  const h = hex.replace("#", "");
  return {
    r: parseInt(h.substring(0, 2), 16),
    g: parseInt(h.substring(2, 4), 16),
    b: parseInt(h.substring(4, 6), 16),
  };
}
function rgbToHex({ r, g, b }) {
  const toHex = (x) => x.toString(16).padStart(2, "0");
  return `#${toHex(Math.round(r))}${toHex(Math.round(g))}${toHex(Math.round(b))}`;
}
function interpolateHex(c1, c2, t) {
  const a = hexToRgb(c1);
  const b = hexToRgb(c2);
  return rgbToHex({
    r: lerp(a.r, b.r, t),
    g: lerp(a.g, b.g, t),
    b: lerp(a.b, b.b, t),
  });
}
function valueToColor(v, vMin, vMax) {
  if (v === null || v === undefined) return "transparent";
  const t = Math.min(1, Math.max(0, (v - vMin) / (vMax - vMin)));
  const blue = "#08306b";
  const white = "#f7f7f7";
  const green = "#2ca25f";
  if (t <= 0.5) return interpolateHex(blue, white, t / 0.5);
  return interpolateHex(white, green, (t - 0.5) / 0.5);
}

// ===============================
// 3) Tooltip sentence builder
//    A = x-axis label text
//    B = y-axis label text
//    C = OS or PFS from y-axis label suffix
//    D = cell value (months)
// ===============================



const { Header, Content, Footer, Sider } = Layout;
const SubMenu = Menu.SubMenu;
const { Meta } = Card;

const Ajax = require('axios');

class ClarityICIIntroAnn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoverCell: null, // { r, c }
      tooltip: {
        visible: false,
        x: 0,
        y: 0,
        text: "",
      },
    };
  }

  

  render() {
    return (
      <div>
        <Header1></Header1>
        <Content style={{ padding: '0 50px' }}>
          <Layout style={{ background: '#fff' }}>
            <Sider width={200} style={{ background: '#fff' }}>
              <Menu
                mode="inline"
                defaultSelectedKeys={['5']}
                defaultOpenKeys={['sub1']}
                style={{ height: '100%' }}
              >
                <SubMenu key="sub1" title={<span><Icon type="user" />CLARITY-ICI</span>}>
                <Menu.Item key="1"><Link to="/clarityICI">Introduction</Link></Menu.Item>
                <Menu.Item key="2"><Link to="/clarityICIAll">All Population</Link></Menu.Item>
                <Menu.Item key="3"><Link to="/clarityICIWestern">Western</Link></Menu.Item>
                <Menu.Item key="4"><Link to="/clarityICIEastAsian">East Asian</Link></Menu.Item>
                <Menu.Item key="5"><Link to="/clarityICIIntroAnn">Animation</Link></Menu.Item>
                </SubMenu>
              </Menu>
            </Sider>

            <Content style={{ padding: '0 50px' }}>
              <div
                style={{
                  background: `url(${BicombImg}) no-repeat center center`,
                  height: 300,
                  width: "100%",
                  backgroundSize: "cover",
                }}
              >
                <div style={{ textAlign: "center", color: "#fff" }}>
                  <br></br><br></br><br></br>
                  <txt style={{ fontSize: 45, fontWeight: 'bold' }}>
                    Clinical Attribute–Based Risk Matrix for Prognostication in Immunotherapy-Treated NSCLC
                  </txt>
                  <br></br>
                </div>
              </div>

              <div>
                <br></br>
                <br></br>
                <txt style={{ fontSize: 23, fontWeight: 'bold', paddingRight: 100 }}>
                  Introduction of CLARITY-ICI Matrix
                </txt>
                <br></br>

                <div style={{ fontSize: 20, paddingRight: 200 }}>
                  <txt>
                    <br></br>
                    Demonstrating the clinical implementation process of the CLARITY-ICI Matrix.

                    <br></br>

                    <video
                      src={DemoVideo}
                      controls
                      preload="metadata"
                      loop={false}
                      style={{
                        width: "100%",
                        maxWidth: 900,
                        borderRadius: 8,
                        display: "block",
                        marginTop: 12,
                        marginBottom: 24,
                        backgroundColor: "#000"
                      }}
                      onClick={(e) => {
                        // Click-to-play/pause (in addition to native controls)
                        if (e.target.paused) e.target.play();
                        else e.target.pause();
                      }}
                    />

                    <br></br>


                    <br></br><br></br>Please cite the following study if use the information in this website:
                    <br></br><br></br>
                    <txt style={{ fontStyle: 'italic' }}>
                     Clinical Attribute–Based Risk Matrix for Prognostication in Immunotherapy-Treated Non-Small-Cell Lung Cancer: An Individual-Patient Data Analysis of 17051 Patients.
                    </txt>
                    <br></br><br></br>

            
                  </txt>
                </div>
              </div>

            </Content>
          </Layout>
        </Content>
      </div>
    );
  }
}

export default ClarityICIIntroAnn;
